// Chemin: C:\gestion-copro\src\services\firebase.ts
// Configuration Firebase
// Projet : gestion-copro-c6ec2
// Configuré en Session 2

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyA3nUTU7roioxndi97Cq8p8QaaF5Ha1wG8",
  authDomain: "gestion-copro-c6ec2.firebaseapp.com",
  projectId: "gestion-copro-c6ec2",
  storageBucket: "gestion-copro-c6ec2.firebasestorage.app",
  messagingSenderId: "691234066378",
  appId: "1:691234066378:web:a390f89544f1cd14d40933"
};

// Initialisation Firebase
const app = initializeApp(firebaseConfig);

// Services Firebase
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west1');

export default app;